import React from 'react';
import { Modal, makeStyles, Theme, createStyles, Backdrop, Fade } from '@material-ui/core';

import { CreateNotificationForm } from './CreateNotificationForm';
import { useCancelRoute } from 'hooks';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    form: {
      backgroundColor: theme.palette.background.paper,
      border: '0px',
      borderRadius: '2px',
      boxShadow: theme.shadows[5],
    },
  })
);

export const CreateNotificationPage = () => {
  const classes = useStyles();

  const { onCancel } = useCancelRoute('/notifications');

  return (
    <Modal
      open={true}
      onClose={onCancel}
      aria-labelledby="Добавление версии клиента"
      aria-describedby="Используйте эту форму для создания новой версии клиента"
      className={classes.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={true}>
        <div className={classes.form}>
          <CreateNotificationForm onClose={onCancel} />
        </div>
      </Fade>
    </Modal>
  );
};
